import React from "react";
import { Tabs } from "antd";
import UserManageView from "./UserManageView";
import EmployeeView from "./EmployeeView";


export default function UserSettingView() {
  const [activeTab, setActiveTab] = React.useState("user");

  const tableRef = React.useRef(null);

  const items = [
    {
      key: "user",
      label: "ผู้ใช้งาน",
      children: <UserManageView isDone={false} ref={tableRef} />,
    },
    {
      key: "employee",
      label: "Pin พนักงาน",
      children: <EmployeeView/>,
    }
  ];

  return (
    <div style={{ marginTop: 20 }}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="pond"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        style={{ marginTop: 15 }}
      />
    </div>
  );
}
